import { DataStore } from '~/store';

export const useExperience = () => {
  /**
   * Store
   */
  const showFundsExperience = DataStore.useStoreState(
    s => s.settings.globalAppSettings?.showFundsExperience
  );

  // return true;
  return showFundsExperience
};
